<template>
  <div class="crud_module--related_info_data_table"> 
    <Popup ref="modal_popup">
      <InnerViewDetailsModal :setting="$setting.crud[option.key].view" :data="rows[selected_row]" :namespace="key"/>
    </Popup>
    <Popup ref="mass_update_popup">
        <MassUpdateModal :close="closePopup" :selectedCpIdArray="selectedCpIds" />
    </Popup>
    <table class="filter-table">
      <thead>
        <tr>
          <th v-for="(field,index) in option.fields" :key="field.key" :width="field.width">
            <el-tag 
              v-if="Array.isArray(filter[field.key]) || ['string','number'].includes(typeof filter[field.key])"
              @close="closeTag(field.key)"
              size="mini"
              closable
            >
              {{ filter.hasOwnProperty(field.key) ? getFilterValue(field) : "" }}
            </el-tag>
          </th>
        </tr>
      </thead>
    </table>
    <vxe-table
      ref="table"
      size="mini"
      border
      show-header-overflow
      show-overflow
      highlight-hover-row
      :empty-text="$t('label.no_data_found')"
      :remote-sort="true"
      @sort-change="sortChanged"
      @filter-change="filterChanged"
      :loading="loading"
      :key="new Date().getTime()"
      :data="rows">
      <vxe-table-column
        v-for="(field,index) in option.fields" :key="field.key"
        :field="field.key"
        :title="field.key"
        :width="field.width"
        :sortable="option.sort_fields ? option.sort_fields.includes(field.key) : false"
        :filters="field.type != 'action-btn' && option.filters && option.filters.hasOwnProperty(field.key) ? [option.filters[field.key].hasOwnProperty('type') && ['select','multiselect'].includes(option.filters[field.key].type) ? false : ''] : null"
        :filter-render="
              option.filters && option.filters.hasOwnProperty(field.key) && option.filters[field.key].hasOwnProperty('type') 
                ? {name: filter_type_mapping[option.filters[field.key].type], options: ['select','multiselect'].includes(option.filters[field.key].type) 
                  ? options[option.options[field.key].key] 
                  : [], props: {type: 'daterange', format: 'yyyy-MM-dd'}, filterable: option.filters[field.key].filterable } 
                : {name:'FilterInput'}
            "
        :filter-change="filterChanged"
      >
        <template v-slot:header="{ columnIndex }">
          <div class="header-wrap">
            <div class="name">
              {{ tran(key, option.fields[columnIndex].key) }}
            </div>
            <div v-if="option.fields[columnIndex].type == 'mass_update'">
              <el-button
                size="mini"
                @click="showMassUpdateDetails"
                :disabled="selectedCpIds.length == 0 ? true : false"
              >
                {{$t("button.mass_update")}}
              </el-button>
              <fa :icon="['fas','check-double']" @click="toggleAllMassUpdates" size="lg"/>
          </div>
          </div>
        </template>
        <template v-slot="{ row, rowIndex }">
          <div v-if="field.type == 'boolean'">
            <el-checkbox :checked="row[field.key] == 1"/>
            <div class="block-layer"></div>
          </div>

          <div v-else-if="field.type == 'datetime'">
            {{ row[field.key] ? $moment(row[field.key]).format("YYYY-MM-DD HH:mm:ss") : "" }}
          </div>

          <div v-else-if="field.type == 's_to_hms'">
            {{ row[field.key] ? getTime(row[field.key]) : "" }}
          </div>

          <div v-else-if="field.type == 'float'">
            {{ getFloating( field, field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] ) }}
          </div>

          <div class="action" v-else-if="field.type == 'action-btn'">
            <div>
              <el-button
                type="info"
                size="mini"
                @click="showDetails(rowIndex)"
                v-if="option.action.includes('view')"
              >
                <fa :icon="['fas', 'list-alt']"/>
              </el-button>
            </div>
          </div>

          <div v-else-if="field.type == 'mass_update'">
            <el-checkbox v-model="mass_updates.selected[row.cp_id]"></el-checkbox>
          </div>

          <div v-else>{{ field.hasOwnProperty("field") ? getValueByField(row, field) : row[field.key] }}</div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="footer">
      <div class="result">
        {{ $tc("label.total_record_desc", pagination.max == 0 ? 1 : 2, { row: pagination.item, page: pagination.current, max_page: pagination.max }) }}
        <span>, <label>{{$t('label.show_per_page')}}</label></span>     
        <select v-model="pagination.perPage"
        @change="fetchData"
        >
          <option v-for="showPerPageOption in [20,50,100,200]" :key="showPerPageOption.id">{{ showPerPageOption }}</option>
        </select>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @current-change="changePage"
          :current-page.sync="pagination.current"
          :page-size="1"
          layout="jumper, prev, pager, next"
          :total="pagination.max">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ViewDetailsModal from "@/views/crud/modules/ViewDetailsModal";
import MassUpdateModal from "@/views/crud/modules/MassUpdateModal";

export default {
  name: "RelatedInfoDataTable",
  components: {
    InnerViewDetailsModal: ViewDetailsModal,
    MassUpdateModal
  },
  props: {
    option: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  async beforeMount() {
    this.key = this.option.key;
    this.option.fields = [...this.option.fields.filter(f=>{
      if(f.type == "action-btn") return typeof this.option.action != "undefined" && this.option.action.length > 0;
      if(typeof f.hidden == "undefined") return true;
      if(f.hidden.includes("list")) return false;
      return true;
    })];
    console.log("params: ",this.params);
    this.fetchData();
  },
  computed: {
      selectedCpIds: function() {
        console.log(Object.keys(this.mass_updates.selected).filter(value => this.mass_updates.selected[value] === true));
        return Object.keys(this.mass_updates.selected).filter(value => this.mass_updates.selected[value] === true);
      },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      await this.$axios.get(`/${this.key}`, {
        params: {
          size: this.pagination.perPage,
          page: this.pagination.current > 0 ? this.pagination.current - 1 : 0,
          sort_by: this.sort.field ? this.sort.field : this.option?.sort?.field,
          order: this.sort.order ? this.sort.order : this.option?.sort?.order,
          ...this.filter,
          ...this.params
        }
      }).then(res=>{
        let data = res.data.response.dataset;
        this.rows = data.content;
        this.pagination.max = data.totalPages;
        this.mass_updates.selected = [];
        this.selectedCpIdArray= [];
        for (let i = 0; i < data.content.length; i++) {
          this.mass_updates.selected[data.content[i].cp_id] = false;
        }
        if(this.pagination.current > this.pagination.max && this.pagination.max > 0) {
          this.pagination.current = this.pagination.max;
          this.fetchData();
        }
        this.pagination.item = data.totalElements;
        this.$refs.table.updateData();
      }).catch(err=>err);

      if(this.option.options) {
        await this.$axios.get(`options?opts=${Object.keys(this.option.options).map(key=>this.option.options[key].key).join("&opts=")}`, {
          params: {
            // opts: 
          }
        }).then(res=>{
          let options = res.data.response.options;
  
          Object.keys(this.option.options).filter(opt=>options.hasOwnProperty(this.option.options[opt].key)).map(opt=>{
            console.log(opt);
            let key = this.option.options[opt].key;
            this.options[key] = options[key].map(value=>{
              return {
                label: value[this.option.options[opt].label],
                value: value[this.option.options[opt].value],
              }
            });
          });
          return true;
        }).catch(err=>{ return false; });
      }
      this.loading = false;
    },
    clickedCell({ rowIndex }) {
      this.selected_row = rowIndex;
    },
    getFloating(field, value) {
      if(field.decimal_point) {
        return (value/1000).toFixed(field.decimal_point);
      }else {
        return value/1000;
      }
    },
    getValueByField(row, field) {
      // if(Array.isArray())
      // console.log(field);
      let split = field.field.split(".");
      let value = row;
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(typeof value != "object" || value == null) return;
        if(Array.isArray(value[f]) && split.length >= 2) {
          let list = value[f];
          value = list.map(arr=>arr[split[1]]).join(", ");

        }else {
          value = value.hasOwnProperty(f) ? value[f] : "";
        }
      });
      return value;
    },
    fillZero(str) {
      let abs = Math.abs(str);
      return abs < 10 ? `0${abs}` : abs;
    },
    getTime(sec) {
      // let h = Math.abs(Math.floor(sec/(60*60)));
      let h = Math.floor(sec/(60*60));
      let m = Math.floor(sec/(60)) - h*60;
      let s = sec%60;

      if(sec > 0) {
        return `${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }else {
        return `-${this.fillZero(h)}:${this.fillZero(m)}:${this.fillZero(s)}`;
      }
    },
    changePage(page) {
      this.selected_row = -1;
      this.pagination.current = page;
      this.fetchData();
    },
    sortChanged({column, property, order, $event}) {
      console.log("column: ",column);
      console.log("property: ",property);
      console.log("order: ",order);
      console.log("$event: ",$event);
      this.sort.field = property;
      this.sort.order = order;
      this.fetchData();
    },
    showDetails(index) {
      console.log(index);
      let id = this.option.id ? this.rows[index][this.option.id] : this.rows[index]["id"];
      this.selected = id;
      this.$refs.modal_popup.show();
      console.log("key: ",this.key);
      this.selected_row = index;
      // this.$router.push({ name: "View", params: { key: this.key, id} });
    },
    showMassUpdateDetails() {
      this.$refs.mass_update_popup.show();
    },
    filterChanged({datas, column}) {
      console.warn("column: ",column);
      console.warn("filter changed: ",datas);
      let field_setting = this.option.fields.hasOwnProperty(column.property) ? this.option.fields[column.property] : {};
      let filter_setting = this.option.filters.hasOwnProperty(column.property) ? this.option.filters[column.property] : {};

      if(filter_setting.type == "daterange") {
        this.filter[column.property] = datas.length > 0 ? datas[0].map((data,index)=>{
          if(index == 0) {
            return this.$moment(data).unix();
          }else if(index == 1) {
            // make sure it is 23:59:59
            return this.$moment(data).add(1, "days").unix();
          }
        }) : undefined;
      }else {
        this.filter[column.property] = datas.length > 0 ? datas[0] : undefined;
      }
      this.fetchData();
    },
    getFilterValue(field) {
      if(this.option.options && this.option.options.hasOwnProperty(field.key)) {
        let opt = this.option.options[field.key];
        let value = this.options[opt.key].find(option=>option.value==this.filter[field.key]);
        console.log(this.options[opt.key]);
        return value ? value.label : "";
      }else {
        if(this.option?.filters.hasOwnProperty(field.key) && this.option?.filters[field.key].hasOwnProperty("type") && this.filter.hasOwnProperty(field.key)) {
          let type = this.option.filters[field.key].type;
          if(type == "daterange") {
            if(this.filter[field.key]?.length >= 2) {
              return `${this.$moment.unix(this.filter[field.key][0]).format("YYYY-MM-DD")} ~ ${this.$moment.unix(this.filter[field.key][1]).add(-1, "days").format("YYYY-MM-DD")}`;
            }else {
              return "";
            }
          }else if(type == "boolean") {
            return this.filter[field.key] == 1 ? this.$t("filter.boolean.true") : this.$t("filter.boolean.false");
          }
        }else {
          return this.filter.hasOwnProperty(field.key) ? this.filter[field.key] : "";
        }
      }
    },
    closeTag(key) {
      console.log("close");
      delete this.filter[key];
      this.fetchData();
      this.$forceUpdate();
    },
    toggleAllMassUpdates(){
      for (const cpId in this.mass_updates.selected) {
          this.$set(this.mass_updates.selected, cpId, this.mass_updates.toggle)
        }
      this.mass_updates.toggle = !this.mass_updates.toggle;
      this.$forceUpdate();
    },
    async closePopup() {
      this.$refs.mass_update_popup.close();
    },
  },
  data() {
    return {
      key: "",
      rows: [],
      loading: true,
      selected: -1,
      selected_row: -1,
      pagination: {
        perPage: 10,
        total: 0,
        current: 1,
        item: 0,
        max: 0
      },
      sort: {
        field: "",
        order: ""
      },
      filter_type_mapping: {
        text: "ElInput",
        select: "FilterSelect",
        multiselect: "FilterSelect",
        boolean: "FilterSwitch",
        daterange: "FilterDaterange"
      },
      filter: {},
      options: {},
      mass_updates: {
        selected: {},
        toggle: true
      }
    }
  }

}
</script>

<style lang="scss">
.crud_module--related_info_data_table{
  width: 100%;
  .filter-table{
    border: 0;
    border-spacing: 0;
    border-collapse: separate;
    table-layout: fixed;
    font-size: x-small;
    width: 100%;
    th{
      padding: 5px 0;
      text-align: left;
    }
  }
  .vxe-table--header {
    .svg-inline--fa {
      margin-left: 5px;
    }
  }
  .vxe-table--body{
    .row-clicked{
      background: #ffe48d;
    }
    .vxe-cell{
      // font-size: small;
      .block-layer{
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
    .action{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .el-button{
        padding: 7px 7px;
      }
    }
  }
  .footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .result{
      font-size: small;
    }
    .pagination{
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;
      .page{
        font-size: x-small;
        cursor: pointer;
        user-select: none;
        width: 25px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #c5e1ff;
        border-color: #c5e1ff;
        color: white;
        &:not(:last-child) {
          margin-right: 10px;
        }
        &.current{
          background-color: #409EFF;
          border-color: #409EFF;
        }
      }
    }
  }
}
</style>